export interface IMemberCenterResponse<T = null> {
  from: string;
  err: number;
  data?: T;
  msg?: string;
}

export enum EPasswordStatus {
  NONE = 'none',
  FIRST_LOGIN = 'first-login',
  WEAK_PASSWORD = 'weak-password',
}

export interface ISigninBody {
  account: string;
  password: string;
}

export type TSigninResponse = IMemberCenterResponse<{
  accessToken: string;
  passwordStatus: EPasswordStatus;
  deviceVerified: { email: boolean; emailMask?: string; mobile: boolean };
}>;

export interface IVerifyDeviceBody {
  account: string;
  code: string;
}

export type TVerifyDeviceResponse = IMemberCenterResponse<{
  isValid: boolean;
  type: 'email' | 'mobile';
}>;

export interface IResendVerifyDeviceBody {
  account: string;
  project?: 'OneTeacher';
}

export type TResendVerifyDeviceResponse = IMemberCenterResponse<{
  type: 'email' | 'mobile';
  nextRetryAt: number;
  email?: string;
  phone?: { countryCode?: string; phoneNumber?: string };
}>;

export interface IAvailabilityQuery {
  account?: string;
  email?: string;
}

export type TAvailabilityResponse = IMemberCenterResponse<{
  account?: boolean;
  email?: boolean;
  phone?: boolean;
}>;

export enum EResetPasswordPlatform {
  SMS = 'sms',
  EMAIL = 'email',
}

export interface IInitiateResetPasswordBody {
  account: string;
  platform?: EResetPasswordPlatform;
}

export type TInitiateResetPasswordResponse = IMemberCenterResponse<{
  sendPlatform: EResetPasswordPlatform;
  nextRetryAt: number;
  phone?: { countryCode?: string; phoneNumber?: string };
  email?: string;
}>;

export interface ICheckResetPasswordBody {
  account: string;
  code: string;
}

export type TCheckResetPasswordResponse = IMemberCenterResponse<{
  isValid: boolean;
}>;

export interface ICompleteResetPasswordBody {
  account: string;
  code: string;
  password: string;
}

export type TCompleteResetPasswordResponse = IMemberCenterResponse<{
  success: boolean;
}>;
